import { IComponentOptions } from 'angular';
import template from './ktable-widget.html';
import controller from './ktable-widget.controller';
import './ktable-widget.scss';

// import './gauge-chart-widget.scss';

/**
 * @type {IComponentOptions}
 */
const component = {
	template,
	bindings: {
		widget: '<',
		parent: '=',
	},
	transclude: true,
	controller,
};

export default component;
